import React from "react";

export default function CardComex({
  img,
  logo,
  nombre,
  empresa,
  cargo,
  texto,
}) {
  const apiUrl = process.env.REACT_APP_STRAPI_URL;

  return (
    <div className="bg-sidom-light dark:bg-sidom-blue w-full md:max-w-[350px] xl:max-w-[390px] h-[400px] border border-sidom-orange rounded-2xl shadow-lg p-6 flex flex-col justify-between">
      <div className="w-full py-4">
        {/* Avatares */}
        <div className="flex items-center gap-2 px-4 mb-4">
          <img
            src={`${apiUrl}${img}`}
            alt={nombre}
            className="w-14 h-14 rounded-full object-cover border border-sidom-dark"
            draggable={false}
          />
          <img
            src={`${apiUrl}${logo}`}
            alt={empresa}
            className="w-14 h-14 rounded-full object-contain border -ml-4 z-10 bg-sidom-light"
            draggable={false}
          />
        </div>

        {/* Nombre y Cargo */}
        <h2 className=" md:text-base lg:text-xl font-bold text-sidom-blue px-4 dark:text-sidom-light mb-1">
          {nombre}
        </h2>
        <p className="text-xs md:text-sm font-semibold text-sidom-blue px-4 dark:text-sidom-light mb-2">
          {cargo}
        </p>

        {/* Descripción con clamp */}
        <p className="text-xs md:text-sm text-sidom-blue dark:text-sidom-light px-4 line-clamp-7">
          {texto}
        </p>
      </div>
    </div>
  );
}
